module.exports = __webpack_public_path__ + "static/media/bajaj_finserv.369259f9.png";